import { memo } from 'react';
import { type PanelConfigPatch } from '../common/panel-grid';
import { type PageCmsPanelRow, type PanelSize } from '../common/panel-types';
import { PanelRow } from '../CustomPage.styled';
import { PanelItem } from './PanelItem';

interface PanelGridRowProps {
  readonly row: PageCmsPanelRow;
  readonly rowIndex: number;
  readonly onSizeChange: (rowIndex: number, panelId: string, size: PanelSize) => void;
  readonly onDeletePanel: (rowIndex: number, panelId: string) => void;
  readonly onConfigChange: (rowIndex: number, panelId: string, patch: PanelConfigPatch) => void;
  readonly showPanelErrors: boolean;
}

const PanelGridRowComponent = ({
  row,
  rowIndex,
  onSizeChange,
  onDeletePanel,
  onConfigChange,
  showPanelErrors
}: PanelGridRowProps) => (
  <PanelRow data-testid={`panel-grid-row-${rowIndex}`}>
    {row.map((panel) => (
      <PanelItem
        key={panel.id}
        panel={panel}
        panelCount={row.length}
        rowIndex={rowIndex}
        onSizeChange={onSizeChange}
        onDeletePanel={onDeletePanel}
        onConfigChange={onConfigChange}
        showPanelErrors={showPanelErrors}
      />
    ))}
  </PanelRow>
);

// Panel edits are immutable, so untouched rows keep their `row` reference and skip re-rendering.
export const PanelGridRow = memo(PanelGridRowComponent);
